import React, { useEffect, useState } from "react";
import StyledReportEvent from "./StyledReportEvent";

import { ReactComponent as Phone } from "../../../assets/icons/phone.svg";
import { ReactComponent as Email } from "../../../assets/icons/email.svg";

import Footer from "../../common/Footer/Footer";

import { ReactComponent as Print } from "../../../assets/icons/print.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrowDown.svg";

import PregnancyReportForm from "../PatientMaterial/Brochures/PDFs/PregnancyReportForm.pdf";
import PregnancyOutcomeForm from "../PatientMaterial/Brochures/PDFs/PregnancyOutcomeForm.pdf";
import AdverseEventReportForm from "../PatientMaterial/Brochures/PDFs/AdverseEventReportForm.pdf";
import { handleCatch } from "../../../shared/helpers";
import APIVariables from "../../../services/api-variables";
import axios from "axios";
import LocalStorage from "../../../shared/localStorage";

const ReportEvent = () => {
  const patientsBrochures = [
    {
      name: "Lenalidomide Pregnancy Report Form",
      file: PregnancyReportForm,
    },
    {
      name: "Lenalidomide Pregnancy Outcome Form",
      file: PregnancyOutcomeForm,
    },
    {
      name: "Lenalidomide Adverse Event Report form",
      file: AdverseEventReportForm,
    },
  ];

  const print = (event) => {
    if (event.target.tagName === "DIV") {
      window.open(event.target.getAttribute("file"));
    } else {
      let event_ = event.target.parentElement;
      if (event_?.tagName === "svg") {
        event_ = event_?.parentElement;
      }
      const doc = event_.getAttribute("file");
      window.open(doc);
    }
  };
  const [reportAdverseEvent, setReportAdverseEvent] = useState([]);

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const getContactUsDetails = async () => {
    const res = await axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.REPORT_ADVERSE, {
        headers: {
          Authorization: parseLocalStorage?.token,
        },
      })
      .catch((error) => {
        handleCatch(error);
      });

    if (res?.status === 200) {
      setReportAdverseEvent(res.data);
    }
  };

  useEffect(() => {
    getContactUsDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledReportEvent>
      <div className="layout">
        <div className="font-size-30 bold aqua-deep">
          Report an Adverse Event or Pregnancy
        </div>
        <div className="mt-5 mb-2 cards-div">
          <div className="font-size-16 mt-1 justify">
            Adverse Events and cases of suspected or confirmed pregnancy or
            foetal exposure should be reported. Adverse Event Report forms and
            Pregnancy Reporting forms can be found below and should be forwarded
            to the relevant Marketing Authorisation Holder.
          </div>
          <div className="container">
            <div className="row brochure-container">
              {patientsBrochures.map((brochure, index) => (
                <div className="col-lg-4 brochure-card" key={index}>
                  <span className="font-size-18 aqua-deep">
                    {brochure.name}
                  </span>
                  <div className="brochuer-buttons-report-event">
                    <div onClick={print} file={brochure.file}>
                      <span>Print</span>
                      <Print />
                    </div>
                    <a
                      className="bg-transparent border-0 hover-class"
                      href={brochure.file}
                      download
                    >
                      <span> Download</span>
                      <ArrowDown />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-5 mb-2">
          <div
            className="font-size-18 aqua-deep bold"
            style={{ marginTop: "80px" }}
          >
            Medical Information and Adverse Event MAH contact:
          </div>
          <div>
            <div>
              <div className="wrapper-tehnical-report mt-3">
                {reportAdverseEvent.map((reportEvent, index) => (
                  <div key={index + 1} className={"contact-us-card"}>
                    <div>
                      <div className="font-size-18 aqua-deep bold">
                        {reportEvent.name}:
                      </div>
                      <p>For reporting adverse events:</p>
                      <Phone />{" "}
                      <span className="font-size-16 bold">
                        Tel:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`tel:${reportEvent.adverse_event_phone_number}`}
                        >
                          {reportEvent.adverse_event_phone_number}
                        </a>
                      </span>
                    </div>
                    <div>
                      <Email />{" "}
                      <span className="font-size-16 bold">
                        Email:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`mailto:${reportEvent.adverse_event_email}`}
                        >
                          {reportEvent.adverse_event_email}
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </StyledReportEvent>
  );
};
export default ReportEvent;
